import { CloudFile } from './cloudFile';
import { City } from './race';

export const REGISTRATION_SOURCE = {
  SELF: 'SELF',
  ADDED_IN_CREW: 'ADDED_IN_CREW',
} as const;

export class User {
  cUid!: string;
  name!: string;
  internationalName!: string;
  team!: string;
  birthdate!: Date;
  phone: string = '';
  email!: string;
  city!: string;
  citizenship!: string;
  sportTitle!: string;
  gender!: number;
  photo!: string;
  info!: string;
  motto!: string;
  profileType: number = 1;
  images: Array<CloudFile> = [];
  files: Array<CloudFile> = [];
  links: Array<CloudFile> = [];
  cityObject!: City;
  isPhoneVerified: number = 0;
  isEmailVerified: number = 0;
  competitorCount: number = 0;
  orgCount: number = 0;

  phoneOld!: string | null;
  emailOld!: string;
  password!: string;
  password_retype!: string;

  setData: boolean;
  admin!: boolean;
  betaTester!: boolean;
  isOrg!: boolean;

  profileOwner: boolean = false;

  registrationSource: (typeof REGISTRATION_SOURCE)[keyof typeof REGISTRATION_SOURCE] =
    REGISTRATION_SOURCE.SELF;

  age: { age: number; str_age: string; ageTimeInRaceDate: number } = {
    age: 0,
    str_age: '',
    ageTimeInRaceDate: 0,
  };

  constructor(obj?: any, profileOwner?: boolean) {
    if (obj) {
      this.profileOwner = profileOwner ? profileOwner : false;
      this.cUid = this.setValue(obj.cUid);
      this.name = obj.name;
      this.internationalName = obj.internationalName;
      this.team = obj.team ? obj.team : '';
      if (obj.birthdate && obj.birthdate.length) {
        const arrDateDOB = obj.birthdate.split('-');
        if (Number(arrDateDOB[0]).toString() !== 'NaN') {
          this.birthdate = new Date(
            Number(arrDateDOB[0]),
            Number(arrDateDOB[1]) - 1,
            Number(arrDateDOB[2]),
            0,
            0,
            0,
            0
          );
        }
      }
      const phone = obj.phone;
      if (phone.split('+').length > 1) {
        this.phone = phone;
      } else {
        this.phone = `+${phone}`;
      }
      this.email = obj.email;
      this.city = obj.city;
      this.citizenship = obj.citizenship ? obj.citizenship.toLowerCase() : '';
      this.sportTitle = obj.sportTitle;
      this.gender = obj.gender;
      this.photo = obj.photo;
      this.info = obj.info;
      this.motto = obj.motto;
      this.profileType = obj.profileType ? 1 : 0;
      this.images = obj.images && obj.images.length ? obj.images : [];
      this.links = obj.links && obj.links.length ? obj.links : [];
      if (obj.files && obj.files.length) {
        obj.files.forEach((file: any) => {
          file.uid_clear = file.uid.split('.')[0];
        });
      }      
      this.files = obj.files && obj.files.length ? obj.files : [];
      this.cityObject = obj.cityObject;
      this.isPhoneVerified = obj.isPhoneVerified ? 1 : 0;
      this.isEmailVerified = obj.isEmailVerified ? 1 : 0;
      this.competitorCount = obj.competitorCount;
      this.orgCount = obj.orgCount;

      this.phoneOld = this.phone;
      this.emailOld = obj.email;

      this.setData = obj.setData;
      this.admin = obj.admin;
      this.betaTester = obj.betaTester;
      this.isOrg = obj.isOrg;
      this.orgCount = obj.orgCount;
      this.competitorCount = obj.competitorCount;

      this.age = this.getAge(this.birthdate);

      this.registrationSource = obj.registrationSource
        ? obj.registrationSource
        : REGISTRATION_SOURCE.SELF;
    } else {
      this.setData = false;
    }
  }

  setValue(value: any) {
    return value?.length ? value : null;
  }

  getAge(birthDate: Date): {
    age: number;
    str_age: string;
    ageTimeInRaceDate: number;
  } {
    if (!birthDate) {
      return { age: 0, str_age: '', ageTimeInRaceDate: 0 };
    }
    let today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const ageTimeInRaceDate = birthDate.getTime();

    let m = today.getMonth() - birthDate.getMonth();
    let d = today.getDay() - birthDate.getDay();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    if (age === 0) {
      m = 12 + m;
      if (d < 0 || (d === 0 && today.getDate() < birthDate.getDate())) {
        m--;
      }
    }

    const retData = {
      age,
      str_age: age ? age + ' лет' : m + ' мес.',
      ageTimeInRaceDate,
    };

    return retData;
  }

  getUserAge(raceDate: Date | null | undefined) {
    if (!this.birthdate) return 0;
    const dob = new Date(this.birthdate);
    const today = new Date();

    if (raceDate) {
      const raceleftTime = raceDate.getTime() - today.getTime();
      dob.setTime(this.birthdate.getTime() - raceleftTime);
    }
    const ageData = this.getAge(dob);
    return ageData.age;
  }
}
